/* eslint-disable no-unused-vars */

import Api from 'src/services/ApiService';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { CommonAxiosResponse } from 'src/types';
import {
  CreateEmailerRequest,
  CreateEmailerResponse,
  GetEmailerDetailsRequest,
  GetEmailerDetailsResponse,
  GetEmailerListRequest,
  GetEmailerListResponse,
  UpdateEmailerDetailsRequest,
  UpdateEmailerDetailsResponse,
  UploadImageEmailAssetPayload,
  UploadImageEmailAssetResponse
} from './types';

export const getEmailerListThunk = createAsyncThunk<
  CommonAxiosResponse<GetEmailerListResponse>,
  GetEmailerListRequest
>('emailer/getEmailerListThunk', async (data) => {
  const response = await Api.get(`/emailer/list/get`, data);
  return response;
});

export const getEmailerDetailsThunk = createAsyncThunk<
  CommonAxiosResponse<GetEmailerDetailsResponse>,
  GetEmailerDetailsRequest
>('emailer/getEmailerDetailsThunk', async (data) => {
  const response = await Api.get(`/emailer/details/get/${data.id}`);
  return response;
});

export const createEmailerThunk = createAsyncThunk<
  CommonAxiosResponse<CreateEmailerResponse>,
  CreateEmailerRequest
>('emailer/createEmailerThunk', async (data) => {
  const response = await Api.post(`/emailer/create`, data);
  return response;
});

export const updateEmailerDetailsThunk = createAsyncThunk<
  CommonAxiosResponse<UpdateEmailerDetailsResponse>,
  UpdateEmailerDetailsRequest
>('emailer/updateEmailerDetailsThunk', async (data) => {
  const { id, ...payload } = data;

  const response = await Api.patch(`/emailer/update/${id}`, payload);
  return response;
});

export const updateEmailerContentThunk = createAsyncThunk<
  CommonAxiosResponse<UpdateEmailerDetailsResponse>,
  UpdateEmailerDetailsRequest
>('emailer/updateEmailerContentThunk', async (data) => {
  const { id, ...payload } = data;
  payload['action'] = 'update_content';

  const response = await Api.patch(`/emailer/update/${id}`, payload);
  return response;
});

export const uploadEmailImageAssetThunk = createAsyncThunk<
  CommonAxiosResponse<UploadImageEmailAssetResponse>,
  UploadImageEmailAssetPayload
>('emailer/uploadEmailImageAssetThunk', async (data) => {
  const response = await Api.post(`/emailer/email_image/upload`, data);
  return response;
});
